<template>
  <RiskAnalysisPage />
</template>

<script setup lang="ts">
import RiskAnalysisPage from "shared-ui/pages/RiskAnalysisPage.vue";

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
